import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Quality'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z"
          fill="#D7D7FF"
        />
        <path
          d="M31.4672 15.5999L24.66 22.4071C24.4852 22.5822 24.2479 22.6806 24.0004 22.6806C23.753 22.6806 23.5157 22.5822 23.3409 22.4071L21.2004 20.2666"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9368 25.4333L10 31.4665L14.6667 32.3999L16.5334 38L21.4989 30.12"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.0635 25.4333L38.0003 31.4665L33.3336 32.3999L31.4669 38L26.5015 30.12"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.3338 20.9348L34.3842 23.6926C34.5411 24.1025 34.3908 24.5664 34.0233 24.8064L31.5518 26.4242L30.7802 29.274C30.6655 29.6975 30.2713 29.9839 29.8331 29.9622L26.885 29.8153L24.5865 31.6671C24.2441 31.9422 23.7566 31.9422 23.4142 31.6671L21.1157 29.8116L18.1675 29.9585C17.7293 29.9802 17.3352 29.6937 17.2205 29.2703L16.4489 26.4204L13.9774 24.8026C13.6099 24.5627 13.4595 24.0988 13.6165 23.6888L14.6668 20.9348L13.6165 18.1759C13.4567 17.7642 13.6073 17.2968 13.9774 17.0558L16.4489 15.438L17.2205 12.5882C17.3352 12.1647 17.7293 11.8783 18.1675 11.9L21.1157 12.0531L23.4142 10.2063C23.7566 9.93123 24.2441 9.93123 24.5865 10.2063L26.885 12.0531"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
